import React, { useState } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { FaStar, FaRegStar } from "react-icons/fa";
import { Button, Container, Modal, Col, Form, Row, Dropdown, FormControl } from 'react-bootstrap';
import Footer from '../Footer/Footer';
import { Link } from 'react-router-dom';

const products = [
  {
    id: 1,
    ProductName: "Banana Accounting",
    image: "https://cryptologos.cc/logos/arbitrum-arb-logo.png",
    EntryLevelPrice: "$2.98 Per Month",
    location: "New York, USA",
    Category: "Fitness Software",
    rating: 3.9,
    review: 125,
    description: "Mauris ornare varius sem, ac tempor metus. Maecenas eu nulla dapibus, vestibulum dolor a, porta tellus. Curabitur sit amet tempus neque, nec mattis turpis. "
  },
  {
    id: 2,
    ProductName: "QuickBooks Online",
    image: "https://www.logoai.com/oss/icons/2021/12/02/TUhJtD3NM0l-Vtq.png",
    EntryLevelPrice: "$5.99 Per Month",
    location: "San Francisco, USA",
    Category: "Cloud Computing",
    rating: 3.9,
    review: 125,
    description: "Mauris ornare varius sem, ac tempor metus. Maecenas eu nulla dapibus, vestibulum dolor a, porta tellus. Curabitur sit amet tempus neque, nec mattis turpis."
  }

  ,
  {
    id: 3,
    ProductName: "Zoho Books",
    image: "https://www.freepnglogos.com/uploads/shopee-logo-png/shopee-logo-shop-with-the-gentlemen-collection-and-win-the-shopee-0.png",
    EntryLevelPrice: "$5.99 Per Month",
    location: "San Francisco, USA",
    Category: "Cloud Computing",
    rating: 3.9,
    review: 125,
    description: "Mauris ornare varius sem, ac tempor metus. Maecenas eu nulla dapibus, vestibulum dolor a, porta tellus. Curabitur sit amet tempus neque, nec mattis turpis."
  }

  ,
  {
    id: 4,
    ProductName: "Sage Intacct",
    image: "https://png.pngtree.com/png-vector/20240607/ourmid/pngtree-unique-logo-designs-colorful-abstract-images-modern-artistic-logos-creative-art-png-image_12575011.png",
    EntryLevelPrice: "$5.99 Per Month",
    location: "San Francisco, USA",
    Category: "Cloud Computing",
    rating: 3.9,
    review: 125,
    description: "Mauris ornare varius sem, ac tempor metus. Maecenas eu nulla dapibus, vestibulum dolor a, porta tellus. Curabitur sit amet tempus neque, nec mattis turpis."
  }
];

function ProductListComponent() {

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const navigate = useNavigate();
  const [bookmarked, setBookmarked] = useState({});

  const toggleBookmark = (id) => {
    setBookmarked(prev => ({ ...prev, [id]: !prev[id] }));
  };






  const [searchTerm, setSearchTerm] = useState({
    location: "",
    solutions: "",
    reviews: "",
  });
  
  const [budgetRange, setBudgetRange] = useState([0, 1000000]);
  const [pricePerMonthRange, setPricePerMonthRange] = useState([0, 500]);
  const [unspecified, setUnspecified] = useState(false);
  
  const filterOptions = {
    solutions: ["Accounts Payable", "Project Accounting", "Expense Tracking", "Purchase Orders", "AI Features"],
    reviews: ["1+", "2+", "3+", "4+"],
  };
  
  const handleSearch = (e, type) => {
    setSearchTerm({ ...searchTerm, [type]: e.target.value });
  };
  
  const handleBudgetChange = (e) => {
    setBudgetRange([budgetRange[0], parseInt(e.target.value, 10)]);
  };
  
  const handlePricePerMonthChange = (e) => {
    setPricePerMonthRange([pricePerMonthRange[0], parseInt(e.target.value, 10)]);
  };
  
  const handleUnspecifiedChange = () => {
    setUnspecified(!unspecified);
  };
  
  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };
  
  const [filters, setFilters] = useState({
    location: "",
    solutions: "",
    pricePerMonth: "",
    reviews: "",
  });




  return (


    <>

<div className="sub-header sub-search py-3 bg-light border-bottom border-top">
        <Container>
          <Row className="align-items-start">
            <Col md={12}>
              <Form className="d-flex flex-md-row flex-column gap-2 gap-md-0">
                <Form.Control
                  type="search"
                  placeholder="e.g. App Development, UX Design, IT Services..."
                  className="me-md-4 px-4 rounded-5 w-100 w-md-auto"
                  aria-label="Search"
                  value="Accounting Software"
                />
                <Form.Control
                  type="text"
                  placeholder="Enter location"
                  className="me-md-4 px-4 rounded-5 w-100 w-md-auto"
                  aria-label="Location"
                />
                <Button variant="primary" className="px-4 rounded-5 w-25 w-md-auto">
                  Search
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>


      <section className="page-header bg-skyblue py-2">
      <div className="container py-4 pb-2">
          <div className="row page-introduction">
            <div className="col-12">
              <div className="d-flex align-items-start justify-content-between">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item small"><a href="#">Home</a></li>
                    <li class="breadcrumb-item small active" aria-current="page">Accounting Software</li>
                  </ol>
                </nav>
                <span><strong>300</strong> Products Listed</span>
              </div>

              <h3 className="mt-2">Best Accounting Software</h3>
              <p className="mini-content">Efficient financial management is fundamental to the success of small and enterprise businesses.</p>
            </div>
          </div>
        </div>
      </section>


      <div className="container my-4">






{/* 2dn filter */}
  <div className="row">
    <div className="col-12">
      <div className="card rounded-3 p-2 bg-white shadow-sm">
        <div className="card-body">
          <div className="d-flex search-filter flex-wrap gap-4">
            {/* Multi-Select Dropdowns */}
            {Object.keys(filterOptions).map((key) => (
              <Dropdown key={key}>
                <Dropdown.Toggle as="div" className="form-select w-auto pe-5">
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </Dropdown.Toggle>
                <Dropdown.Menu className="px-2" style={{ maxHeight: "250px", overflowY: "auto" }}>
                  {key !== "reviews" && (
                    <FormControl
                      type="text"
                      placeholder="Search..."
                      className="mx-2 p-1 px-3 my-2 mb-3 w-auto form-control"
                      onChange={(e) => handleSearch(e, key)}
                    />
                  )}
                  {filterOptions[key]
                    .filter((option) => option.toLowerCase().includes(searchTerm[key].toLowerCase()))
                    .map((option, index) => (
                      <Form.Check
                        className="mx-2 mt-2 small"
                        key={index}
                        type="checkbox"
                        id={`${key}-${index}`}
                        label={option}
                        onChange={(e) => handleFilterChange(e, key, option)}
                      />
                    ))}
                </Dropdown.Menu>
              </Dropdown>
            ))}

            {/* Price Per Month Range Slider */}
            <Dropdown>
              <Dropdown.Toggle
                className="form-select range-slider bg-white text-dark w-auto pe-5"
                style={{ minWidth: "260px", maxWidth: "260px", whiteSpace: "nowrap", textAlign: "center" }}
              >
                Price Per Month: {unspecified ? "Unspecified" : `$${pricePerMonthRange[0]} - $${pricePerMonthRange[1]}`}
              </Dropdown.Toggle>
              <Dropdown.Menu className="p-3">
                <Form.Label className="small">Set Price Per Month</Form.Label>
                <Form.Range
                  min={0}
                  max={500}
                  step={10}
                  value={pricePerMonthRange[1]}
                  onChange={handlePricePerMonthChange}
                  disabled={unspecified}
                />
                <Form.Check
                  type="checkbox"
                  label="Unspecified"
                  className="mt-2"
                  checked={unspecified}
                  onChange={handleUnspecifiedChange}
                />
              </Dropdown.Menu>
            </Dropdown>

          </div>
        </div>
      </div>
    </div>
  </div>







        {/* <div className="row">
          <div className="col-12">
            <div className='card rounded-3 p-2 bg-white shadow-sm'>
              <div className='card-body'>


                <div className="d-flex flex-wrap gap-4">

                  <select name="service" className="form-select w-auto pe-5">
                    <option value="">Features</option>
                    <option value="">Accounts Payable</option>
                    <option value="">Project Accounting</option>
                    <option value="">Expense Tracking</option>
                    <option value="">Purchase Orders</option>
                    <option value="">AI Features</option>
                  </select>

                  <select name="budget" className="form-select w-auto pe-5">
                    <option value="">Price Modal</option>
                    <option value="5000-10000">Free</option>
                    <option value="10000-25000">Monthly</option>
                    <option value="25000-50000">Annual Subscription</option>
                    <option value="50000-100000">One-Time Payment</option>
                  </select>

                  <select name="reviews" className="form-select w-auto pe-5">
                    <option value="">Reviews</option>
                    <option value="4+">4+ Stars</option>
                    <option value="3+">3+ Stars</option>
                    <option value="2+">2+ Stars</option>
                    <option value="1+">1+ Stars</option>
                  </select>


                </div>
              </div>
            </div>
          </div>
        </div> */}






        <div className="row">
          <div className='col-12'>
            <div className="py-4 mt-2 d-flex justify-content-between align-items-center">

              <h5>Here are the 300 Best Accounting Software</h5>

              <div className="d-flex align-items-center">
                <label className="me-2 fw-regular text-muted">Sort By:</label>
                <select className="form-select w-auto pe-5">
                  <option value="sponsored">Sponsored</option>
                  <option value="high-rating">High Rating</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {products.map((product) => (
            <div className='col-sm-12' key={product.id}>
              <div className="d-lg-flex card rounded-4 mb-4 align-items-stretch p-4">
                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between'>
                    <div className='d-flex align-items-center'>
                      <img src={product.image} alt={product.ProductName} className="img-thumbnail p-2 rounded-3 border-1 me-4" style={{ width: "50px", height: "50px" }} />
                      <div>

                      <h5 className="card-title m-0 p-0">
                         <NavLink as={Link} to="/ProductDetailedPage" className='p-0 m-0 text-decoration-none text-dark'>{product.ProductName}</NavLink>                            <span className="ms-3 small verify py-1 rounded-4 fs-6 p-2 text-success"><i class='bx text-success bxs-check-circle' ></i> Verified</span>
                        </h5>
                        <span className="card-text rating">
                          <strong className="me-2"> {product.rating}</strong>
                          {[...Array(5)].map((_, index) =>
                            index < product.rating ? (
                              <FaStar key={index} className="text-warning" />
                            ) : (
                              <FaRegStar key={index} className="text-warning" />
                            )
                          )}
                          <span className="ms-2 small">(26 Reviews)</span>
                        </span>
                      </div>
                      <div>
                      </div>
                    </div>


                    <div className="">
 <button
   className="btn fs-2 p-0 m-0 pt-2 me-3 icon-clr"
   onClick={toggleBookmark}
 >
   <i class="bx bxs-check-shield"></i>
 </button>



                    </div>


                  </div>

                  <div className="d-flex border-top mt-3">

                  <div className="d-flex py-2 w-25 flex-column flex-md-row justify-content-lg-start">
                      <p className="fw-500 mt-3 me-5">
                       <span className='d-block pb-1 small text-muted'>Free Trial</span>
                       <span>30 days</span>
                      </p>
                      <p className="fw-500 mt-3 me-4">
                      <span  className='d-block pb-1 small text-muted'>Starting Price</span>
                      <span>$2.98 Per month/user</span>
                      </p>
                    </div>

                  <div className="w-50 p-4 pb-0"><p className="text-muted">{product.description}... <NavLink
                        to="/ProductDetailedPage"
                        className="btn p-0 btn-link text-primary"
                      >
                        View Product
                      </NavLink></p></div>
                  <div className='mt-2 p-4 pb-0 pe-0 w-25 d-block justify-content-between align-items-center'>
                  <button   onClick={handleShow} className="btn w-100 btn-sm  btn-outline-primary mb-3 text-primary">Schedule Demo</button>


                 <button className="btn w-100 btn-sm btn-outline-primary text-primary">
      Visit Website &nbsp; <i class='bx bx-link-external'></i>
    </button>

                  </div>
                  </div>


                </div>
              </div>
            </div>
          ))}

          <div className="d-flex justify-content-between align-items-center p-3 mb-5">
            <div className="text-muted">Showing 10 of 215</div>
            <nav aria-label="Page navigation">
              <ul className="pagination mb-0">
                <li className="page-item disabled">
                  <button className="page-link">Previous</button>
                </li>
                <li className="page-item active">
                  <button className="page-link">1</button>
                </li>
                <li className="page-item">
                  <button className="page-link">2</button>
                </li>
                <li className="page-item">
                  <button className="page-link">3</button>
                </li>
                <li className="page-item">
                  <button className="page-link">Next</button>
                </li>
              </ul>
            </nav>
          </div>


        </div>
      </div>
      <Footer />
        {/* Modal Popup */}
        <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Schedule a Demo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" placeholder="Enter your name" />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" placeholder="Enter your email" />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Preferred Date & Time</Form.Label>
              <Form.Control type="datetime-local" />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Schedule
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ProductListComponent;